import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { groupBy } from 'es-toolkit';
import { Box, createListCollection, Flex } from '@chakra-ui/react';
import { hasValue } from '@kcast-fe/core';
import { MenuItem } from './components';
const MenuItemsFC = ({ items, activeId, hideActive, onClose }) => {
    const filteredItems = hideActive ? items.filter((i) => i.id !== activeId) : items;
    const optionCollection = createListCollection({
        items: filteredItems.map((opt) => ({ ...opt, value: opt.id })) ?? []
    });
    const hasCategory = hasValue(filteredItems[0]?.category);
    const getCategories = () => {
        return Object.entries(groupBy(optionCollection.items, (item) => item.category));
    };
    return (_jsx(Flex, { gap: '4px', bg: 'white', p: '12px 8px', flexDirection: 'column', borderRadius: '12px', children: hasCategory ? (_jsx(_Fragment, { children: getCategories().map(([category, items]) => (_jsxs(Box, { children: [_jsx(Box, { p: '4px 0 8px 8px', color: '{colors.textPrimary}', fontSize: '16px', fontWeight: 600, children: category }), items.map((item) => (_jsx(MenuItem, { item: item, onClose: onClose, activeId: activeId, hideActive: hideActive }, item.id)))] }, category))) })) : (_jsx(_Fragment, { children: optionCollection.items.map((item) => (_jsx(MenuItem, { item: item, onClose: onClose, activeId: activeId, hideActive: hideActive }, item.id))) })) }));
};
export const MenuItems = memo(MenuItemsFC);
//# sourceMappingURL=MenuItems.js.map